import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { EmptyState } from './EmptyState';
import logger from '../../utils/logger';
// Styles centralized in AdminStyles.css

/**
 * Error Boundary component for graceful error handling
 * Catches JavaScript errors in child components and displays a fallback UI
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error using centralized logger
    logger.error('ErrorBoundary caught an error', { error, errorInfo });
    
    this.setState({
      error,
      errorInfo
    });
  }

  handleReset = () => {
    this.setState({ 
      hasError: false, 
      error: null,
      errorInfo: null
    });
  };

  render() {
    if (this.state.hasError) {
      const { fallback, showDetails = false } = this.props;
      
      if (fallback) {
        return fallback(this.state.error, this.handleReset);
      }

      return (
        <div className="error-boundary">
          <EmptyState
            icon={<i className="bi bi-exclamation-triangle icon-brand"></i>}
            title="Something went wrong"
            message={
              showDetails && this.state.error
                ? this.state.error.toString()
                : 'An unexpected error occurred. Please try refreshing the page.'
            }
            action={
              <button 
                className="admin-btn-primary"
                onClick={this.handleReset}
              >
                <i className="bi bi-arrow-clockwise icon-brand" style={{ marginRight: 8 }}></i>
                Try Again
              </button>
            }
          />
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.func,
  showDetails: PropTypes.bool
};

ErrorBoundary.defaultProps = {
  fallback: null,
  showDetails: false
};

export default ErrorBoundary;

